export default function TV(props: any) {
    return (
        <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="TV_icon" clipPath="url(#clip0_94_5374)">
                <g id="TV">
                    <path
                        id="&#232;&#183;&#175;&#229;&#190;&#132;"
                        d="M24.0128 31.6785V28.6742H15V31.6785"
                        stroke="black"
                        strokeWidth="1.30956"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke-301"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.79213 6.64282H34.2564C35.2462 6.64282 36.0485 7.46481 36.0485 8.4789V27.0995C36.0485 27.9693 35.3604 28.6742 34.5115 28.6742H3.79213C2.80231 28.6742 2 27.8522 2 26.8381V8.4789C2 7.46481 2.80231 6.64282 3.79213 6.64282Z"
                        stroke="black"
                        strokeWidth="1.30956"
                    />
                    <path id="Stroke-302" d="M10 32.1792H28.0257" stroke="black" strokeWidth="1.30956" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_94_5374">
                    <rect width="38" height="38" fill="white" transform="translate(0 0.661377)" />
                </clipPath>
            </defs>
        </svg>
    );
}
